import { supportStore } from './error-support';

// Native validation covers all forms, including plain inputs outside FormField.
// Values are never collected. Browser validation and submission semantics stay intact.
export function installFormErrorFeedback(root: Document = document) {
  const marked = new Map<
    HTMLElement,
    { invalid: string | null; describedBy: string | null; message: HTMLElement }
  >();
  let counter = 0;
  const clear = (target: HTMLElement) => {
    const original = marked.get(target);
    if (!original) return;
    for (const [attribute, value] of [
      ['aria-invalid', original.invalid],
      ['aria-describedby', original.describedBy],
    ] as const) {
      if (value === null) target.removeAttribute(attribute);
      else target.setAttribute(attribute, value);
    }
    original.message.remove();
    marked.delete(target);
  };
  const invalid = (event: Event) => {
    for (const previous of marked.keys()) if (!previous.isConnected) clear(previous);
    const target = event.target;
    if (!(
      target instanceof HTMLInputElement ||
      target instanceof HTMLSelectElement ||
      target instanceof HTMLTextAreaElement
    ))
      return;
    clear(target);
    const required = target.validity.valueMissing;
    const code = required ? 'VAL-001' : 'VAL-003';
    const message = required
      ? 'Preencha este campo obrigatório.'
      : 'Revise o formato ou o limite permitido para este campo.';
    const hint = root.createElement('span');
    hint.id = `support-field-${++counter}`;
    hint.className = 'mt-1 block text-xs text-red-700 dark:text-red-300';
    hint.setAttribute('role', 'alert');
    hint.textContent = `${message} Código: ${code}`;
    marked.set(target, {
      invalid: target.getAttribute('aria-invalid'),
      describedBy: target.getAttribute('aria-describedby'),
      message: hint,
    });
    target.setAttribute('aria-invalid', 'true');
    target.setAttribute(
      'aria-describedby',
      [target.getAttribute('aria-describedby'), hint.id].filter(Boolean).join(' '),
    );
    target.insertAdjacentElement('afterend', hint);
    supportStore.record({
      status: 0,
      occurredAt: new Date().toISOString(),
      support: {
        code,
        technicalCode: required ? 'FIELD_REQUIRED' : 'FIELD_INVALID',
        module: 'Formulários',
        category: 'Validação',
        title: message,
        steps: [
          'Confira os campos destacados no formulário.',
          'Esta validação é local e não confirma nem executa a operação no servidor.',
        ],
        fields: [],
      },
    });
  };
  const input = (event: Event) => {
    if (event.target instanceof HTMLElement) clear(event.target);
  };
  root.addEventListener('invalid', invalid, true);
  root.addEventListener('input', input, true);
  root.addEventListener('change', input, true);
  return () => {
    root.removeEventListener('invalid', invalid, true);
    root.removeEventListener('input', input, true);
    root.removeEventListener('change', input, true);
    for (const target of marked.keys()) clear(target);
  };
}
